import React, { useCallback, useState, useEffect } from 'react';
import { Redirect, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { Layout, Modal, Button } from 'antd';

import Header from 'src/components/Header';
import Navigation from 'src/components/Navigation';
import Loading from 'src/components/common/Loading';
import { isMobile } from 'react-device-detect';
import { useQueryProxy } from 'src/operations/proxy/user';
import { USER_ME } from 'src/operations/queries/getUser';
import { isLogedIn, userInfoVar } from 'src/apollo/cache';
import { getCurrentToken } from '../utils';
import { storage } from 'src/utils/hooks';
import { useAuthCheck } from 'src/utils/hooks';
import { useApolloClient } from '@apollo/client';
import jwtDecode from 'jwt-decode';

const { Content } = Layout;

function useQueryParams() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function PhonicsLayout({ component: Component, logOut, isHeaderStatic = false, closeHeader = false, removeMargin = true, ...rest }) {
  const history = useHistory();
  const location = useLocation();
  const queryParams = useQueryParams();
  const token = getCurrentToken();
  const client = useApolloClient();
  const [loaded, setLoaded] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const [mobileMode, setMobileMode] = useState();
  const [showblock, setshowblock] = useState(false);
  useEffect(() => {
    let portrait = window.matchMedia('(orientation: portrait)');
    if (portrait.matches) {
      setMobileMode(true);
      setshowblock(false);
    }
    portrait.addEventListener('change', function (e) {
      if (e.matches) {
        setMobileMode(true);
      } else {
        setMobileMode(false);
      }
    });
  }, [mobileMode]);

  const handlemode = () => {
    setshowblock(true);
  };

  const { loading, data, error } = useQueryProxy(USER_ME, {
    variables: { token },
    skip: !token,
  });

  useEffect(() => {
    if (error) {
      isLogedIn(false);
      if (location.pathname !== '/login') {
        history.replace('/login');
      }
      setLoaded(true);
    }
  }, [error, history, location.pathname]);

  useEffect(() => {
    if (!isLogedIn() || !token) {
      if (location.pathname !== '/login') {
        history.replace('/login');
      }
    }
  }, [history, token, location.pathname]);

  useEffect(() => {
    if (data?.me) {
      userInfoVar(data?.me);
      setLoaded(true);
    } else if (token) userInfoVar(jwtDecode(token));
  }, [data, loading, token]);

  const onCollapse = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const matchTest = useRouteMatch(['/test/new/:id/:type']);
  useEffect(() => {
    //placement test 용으로 로그인했을 경우, 시험보는 페이지가 아니면 로그아웃 처리한다.
    if (!matchTest && data?.me?.level_test === 1) {
      isLogedIn(false);
      userInfoVar(null);
      client.clearStore();
      client.cache.gc();
      storage.removeItem('culp_token');
      //history.replace('/level-test');
      //return <Redirect to={`/level-test`} />;
    }
  }, [data, matchTest, client]);

  const { isAccepted } = useAuthCheck();

  if (isAccepted === false) {
    return <Redirect path="/" />;
  }
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <>
          {loading || !loaded ? (
            <Loading />
          ) : (
            <Layout>
              {collapsed && <Navigation />}
              {mobileMode && isMobile && (
                <Modal
                  visible={!showblock}
                  onOk={handlemode}
                  onCancel={handlemode}
                  footer={
                    <div>
                      <Button onClick={handlemode}>OK</Button>
                    </div>
                  }
                >
                  <div className="text">
										Phonics Monster는 가로모드로
										<br />
										최적화되어 제작되었습니다.
										<br />
										디바이스를 가로로 돌려주세요.
									</div>
                </Modal>
              )}
              <Layout className="main-layout" style={{ backgroundImage: 'url(https://cdn.cloubot.com/PM/image/BG_all.png)' }}>
                {!queryParams.get('removeHeader') ? (
                  <Header collapsed={collapsed} onCollapse={onCollapse} isStatic={isHeaderStatic} closeHeader={closeHeader} />
                ) : null}
                <Content style={removeMargin ? {} : { margin: '0 16px' }}>
                  <Component {...matchProps} {...rest} />
                </Content>
              </Layout>
            </Layout>
          )}
        </>
      )}
    />
  );
}

export default PhonicsLayout;
